import React from "react"
import { translate } from "../../translations/translations"
import styles from "./Shared.module.css"

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <a
        href="https://sensos.io/privacy-policy/"
        className={styles.footerLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translate("privacy_policy")}
      </a>
      <span className={styles.footerDivider}>|</span>
      <a
        href="https://sensos.io/terms-conditions/"
        className={styles.footerLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translate("terms_conditions")}
      </a>
      <span className={styles.footerDivider}>|</span>
      <span>
        {translate("all_rights_reserved")} &copy; Sensos{" "}
        {new Date().getFullYear()}
      </span>
    </footer>
  )
}

export default Footer
